"use strict";
exports.__esModule = true;
exports.isEmpty = void 0;
var isEmpty = function (obj) {
    if (obj instanceof Array) {
        return obj.length === 0;
    }
    if (typeof obj === 'string' || obj instanceof String) {
        return obj.length === 0;
    }
    if (obj instanceof Object) {
        return Object.keys(obj).length === 0;
    }
    if (obj === null || obj === undefined) {
        return true;
    }
    return false;
};
exports.isEmpty = isEmpty;
//# sourceMappingURL=isEmpty.js.map